// ------------------------------------------------------- //
// Hero Slider
// ------------------------------------------------------ //

$(window).on("load", function () {
  var owl = $(".hero-slider");
  owl.owlCarousel({
    loop: true,
    margin: 0,
    smartSpeed: 500,
    responsiveClass: true,
    autoplay: true,
    autoplayHoverPause: true,
    navText: [
      '<i class="fa fa-angle-left"></i>',
      '<i class="fa fa-angle-right"></i>',
    ],
    responsive: {
      0: {
        items: 1,
        nav: false,
        dots: true,
      },
      600: {
        items: 1,
        nav: false,
        dots: true,
      },
      1120: {
        items: 1,
        dots: false,
        nav: true,
      },
    },
    onRefresh: function () {
      owl.find(".item").height("");
    },
    onRefreshed: function () {
      var maxHeight = 0;
      var items = owl.find(".item");
      items.each(function () {
        var itemHeight = $(this).height();
        if (itemHeight > maxHeight) {
          maxHeight = itemHeight;
        }
      });
      items.height(maxHeight);
    },
  });
});
